import { Component, Inject } from '@angular/core';
import { TranslatorService } from '../../../../services/translator_service';
import { ResponsiveService } from '../../../../services/responsive.service';
import { TranslateModule } from '@ngx-translate/core';
import { RTLDivDirectiveDirective } from '../../../../directives/rtldiv-directive.directive';
import { CommonModule } from '@angular/common';
import { MAT_BOTTOM_SHEET_DATA } from '@angular/material/bottom-sheet';

@Component({
  selector: 'app-activity-panel',
  standalone: true,
  imports: [TranslateModule, RTLDivDirectiveDirective,CommonModule],
  templateUrl: './activity-panel.component.html',
  styleUrl: './activity-panel.component.scss'
})
export class ActivityPanelComponent {
  isMobile: Boolean;
	currentLang;
	translationsObj;

  constructor(private responsiveService: ResponsiveService,private translator: TranslatorService, @Inject(MAT_BOTTOM_SHEET_DATA) public data: any) {
		this.translator.currentLangEmitter$
		.subscribe(async value=>{						
			this.translationsObj = await this.translator.getTranslation(value).toPromise()			 
			this.currentLang = value;	
		})
	}

	ngOnInit() {
		this.onResize();
		this.responsiveService.checkWidth();
  }

  onResize() {
		this.responsiveService.getMobileStatus().subscribe(isMobile => {
		  this.isMobile = isMobile;
		});
	}
}
